import React, { useState, useEffect } from "react";
import apiCall from "../../API/API";
import { toast } from "react-toastify";
import { Row, Col, Container, Button, Form } from "react-bootstrap";
import "../AddFund/AddFund.css"; // Assuming you'll create this file and paste the CSS there

const BroadCastInfo = () => {
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState(false); // true for active (1), false for inactive (0)

  // Function to fetch broadcast information
  const fetchBroadcastInfo = async () => {
    try {
      const { data, error } = await apiCall("GET", "/get-company-info");
      if (data) {
        setMessage(data?.company_info.broadCast?.message || "");
        setStatus(data?.company_info.broadCast?.status === 1 ? true : false);
      }
    } catch (e) {
      console.log(e.message);
      toast.error("Failed to fetch broadcast information.");
    }
  };

  useEffect(() => {
    fetchBroadcastInfo();
  }, []);

  // Function to handle updating broadcast information
  const handleUpdate = async () => {
    try {
      const body = {
        message: message,
        status: status ? 1 : 0,
      };
      console.log("Updating broadcast info with body:", body);
      const { data, error } = await apiCall("POST", `/update-broadcast-info`, body);
      if (error) {
        toast.error(error.message || "An error occurred while updating broadcast info.");
      } else {
        toast.success(data.message || "Broadcast information updated successfully!");
        fetchBroadcastInfo();
      }
    } catch (error) {
      toast.error(error.message || "An error occurred during update.");
    }
  };

  return (
    <React.Fragment>
      <Container className="mt-4"> {/* Added mt-4 for top margin, similar to AddFunds */}
        <section id="add-funds-section"> {/* Reused ID from AddFunds for styling */}
          <div className="d-flex justify-content-center"> {/* Reused class */}
            <h2>Broadcast Information</h2>
          </div>
          <section id="formContent"> {/* Reused ID */}
            <div className="form"> {/* Reused class */}
              <Row>
                <Col lg={6} style={{ margin: "auto" }}>
                  <form onSubmit={(e) => { e.preventDefault(); handleUpdate(); }}> {/* Changed to a proper form submit */}
                    <div id="formFields"> {/* Reused ID */}
                      {/* Message Field */}
                      <div className="mb-3"> {/* Replaced input-group2 with mb-3 for Bootstrap consistency */}
                        <label htmlFor="message">Message:</label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          id="message" // Added ID for label htmlFor
                          name="message"
                          placeholder="Enter broadcast message"
                          value={message}
                          onChange={(e) => setMessage(e.target.value)}
                          required
                        />
                      </div>

                      {/* Status Toggle */}
                      <div className="mb-3" style={{ marginTop: '20px' }}> {/* Replaced input-group2 with mb-3 */}
                        <label>Status:</label>
                        <Form.Check
                          type="switch"
                          id="broadcast-status-switch"
                          label={status ? "Active" : "Inactive"}
                          checked={status}
                          onChange={(e) => setStatus(e.target.checked)}
                        />
                      </div>

                      <Button type="submit" variant="primary" disabled={false}> {/* Type submit for form, disable can be added if needed */}
                        Update Broadcast
                      </Button>
                    </div>
                  </form>
                </Col>
              </Row>
            </div>
          </section>
        </section>
      </Container>
    </React.Fragment>
  );
};

export default BroadCastInfo;